module.exports = __webpack_public_path__ + "static/media/feature-4.dd12a9fe.png";